// extracted by mini-css-extract-plugin
module.exports = {"card_wrapper":"FormCardWrapper_card_wrapper__sTomT"};